import { Col, Image, Modal, Row, Spin } from "antd";
import { Grid } from "antd";
import { MyText } from "../../../common";
import starImage from "../../../../assets/images/pages/SpeechMarathon/star-icon.svg"
import warningImage from "../../../../assets/images/pages/SpeechMarathon/warning-icon.svg"

import { useTranslation } from "react-i18next";

export const HintBlock = () => {
    const { t } = useTranslation("common");
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const WARNING_ITEMS = [
        "за месяц не появилось новых слов/звуков",
        "ребёнок не реагирует на речь",
        "нет понимания инструкций",
    ];

    const HINT_ITEMS = [
        "Любой прогресс – это успех!",
        "Хвалите ребёнка за попытки и маленькие достижения",
        "Вы делаете важную работу каждый день!",
    ];
    return (
        <Col span={24}>
            <Row gutter={24}>
                <Col span={12}>
                    <Row style={{height: '100%',background: '#FEF2F2', border: '1px solid #FFE2E2', borderRadius: 24, padding: 24 }}>
                        <Col span={24}>
                        <Row align="middle" wrap={false} style={{ gap: 16 }}>
                            <Col flex="48px" style={{ flexShrink: 0 }}>
                                <Image
                                    preview={false}
                                    src={warningImage}
                                    width={48}
                                    height={48}
                                />
                            </Col>
                            <Col flex="auto" style={{ minWidth: 0 }}>
                                <MyText
                                    color="#130F26"
                                    size={24}
                                    weight={500}
                                    style={{ display: 'block', lineHeight: '32px' }}
                                >
                                    Обязательно обратитесь к логопеду и неврологу для углублённой диагностики, если:
                                </MyText>
                            </Col>
                        </Row>
                    </Col>

                        <Col span={24} style={{ marginTop: 20, paddingLeft: 10 }}>
                            <Row gutter={[0, 12]}>
                                {WARNING_ITEMS.map((text, i) => (
                                    <Col span={24} key={i}>
                                        <Row gutter={12} align="middle" wrap={false}>
                                            <Col flex="none">
                                                <Row style={{
                                                    width: 24, height: 24, borderRadius: 6,
                                                    background: '#FB2C36',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    flexShrink: 0,
                                                }}>
                                                    <MyText color="#fff" size={13} weight={700}>
                                                        {i + 1}
                                                    </MyText>
                                                </Row>
                                            </Col>
                                            <Col flex="auto">
                                                <MyText color="#130F26" size={18} weight={400} style={{ display: 'block', lineHeight: '24px' }}>
                                                    {text}
                                                </MyText>
                                            </Col>
                                        </Row>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </Col>

                <Col span={12}>
                    <Row style={{height: '100%',background: '#ECFDF5', border: '1px solid #CAECDB', borderRadius: 24, padding: 24 }}>
                        <Col span={24}>
                            <Row align="middle" wrap={false} style={{ gap: 16 }}>
                                <Col flex="48px" style={{ flexShrink: 0 }}>
                                    <Image
                                        preview={false}
                                        src={starImage}
                                        width={48}
                                        height={48}
                                    />
                                </Col>
                                <Col flex="auto" style={{ minWidth: 0 }}>
                                    <MyText
                                        color="#130F26"
                                        size={26}
                                        weight={700}
                                        style={{ display: 'block', lineHeight: '32px' }}
                                    >
                                        Подсказка для родителей:
                                    </MyText>
                                </Col>
                            </Row>
                        </Col>
                         <Col span={24} style={{ marginTop: 20, paddingLeft: 10 }}>
                            <Row gutter={[0, 12]}>
                                {HINT_ITEMS.map((text, i) => (
                                    <Col span={24} key={i}>
                                        <Row gutter={12} align="middle" wrap={false}>
                                            <Col flex="none">
                                                <Row style={{
                                                    width: 24, height: 24, borderRadius: 6,
                                                    background: '#13C296',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    flexShrink: 0,
                                                }}>
                                                    <svg width="14" height="11" viewBox="0 0 14 11" fill="none">
                                                        <path d="M1 5L5 9L13 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </Row>
                                            </Col>
                                            <Col flex="auto">
                                                <MyText color="#130F26" size={18} weight={400} style={{ display: 'block', lineHeight: '24px' }}>
                                                    {text}
                                                </MyText>
                                            </Col>
                                        </Row>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>                
                </Col>
            </Row>
        </Col>
    );
};